module.exports = {"lang":"En","welcome":"Welcome","login":{"title":"login"}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en.json
// module id = yZm8
// module chunks = 1